/**
 * Mobile offcanvas: collapse first-level submenus by default; expand via toggle.
 * Keeps the panel short until the user opens a section.
 */

const PANEL_ID = 'zkMainNav';
const MENU_ROOT_SELECTOR = '#zk-main-menu-mobile .zk-main-menu';
const TOP_ITEM_SELECTOR = ':scope > .zk-main-menu__item--has-children';
const SUBMENU_SELECTOR = ':scope > .zk-main-menu__submenu';
const LINK_SELECTOR = ':scope > .zk-main-menu__link';

function collapseItem(li, btn) {
  li.classList.remove('zk-main-menu__item--submenu-expanded');
  const sm = li.querySelector(SUBMENU_SELECTOR);
  if (sm) {
    sm.hidden = true;
  }
  if (btn) {
    btn.setAttribute('aria-expanded', 'false');
  }
}

function expandItem(li, btn) {
  li.classList.add('zk-main-menu__item--submenu-expanded');
  const sm = li.querySelector(SUBMENU_SELECTOR);
  if (sm) {
    sm.hidden = false;
  }
  if (btn) {
    btn.setAttribute('aria-expanded', 'true');
  }
}

function bindPanel(panel) {
  if (!panel || panel.dataset.zkMobileNavCollapsibleBound === '1') {
    return;
  }
  const menu = panel.querySelector(MENU_ROOT_SELECTOR);
  if (!menu) {
    return;
  }

  const expandVerb = panel.getAttribute('data-zk-nav-expand') || 'Expand';
  const collapseVerb = panel.getAttribute('data-zk-nav-collapse') || 'Collapse';

  let index = 0;
  menu.querySelectorAll(TOP_ITEM_SELECTOR).forEach((li) => {
    if (li.querySelector(':scope > .zk-main-menu__submenu-toggle')) {
      return;
    }
    const link = li.querySelector(LINK_SELECTOR);
    const submenu = li.querySelector(SUBMENU_SELECTOR);
    if (!link || !submenu) {
      return;
    }

    const uid = `zk-mnav-sub-${++index}`;
    submenu.id = submenu.id || uid;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'zk-main-menu__submenu-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', submenu.id);
    const title = link.textContent.replace(/\s+/g, ' ').trim();
    btn.setAttribute('aria-label', `${expandVerb}: ${title}`);

    collapseItem(li, btn);

    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const isOpen = li.classList.contains('zk-main-menu__item--submenu-expanded');
      if (isOpen) {
        collapseItem(li, btn);
        btn.setAttribute('aria-label', `${expandVerb}: ${title}`);
      }
      else {
        expandItem(li, btn);
        btn.setAttribute('aria-label', `${collapseVerb}: ${title}`);
      }
    });

    link.insertAdjacentElement('afterend', btn);
  });

  panel.dataset.zkMobileNavCollapsibleBound = '1';

  panel.addEventListener('hidden.bs.offcanvas', () => {
    menu.querySelectorAll(TOP_ITEM_SELECTOR).forEach((li) => {
      const btn = li.querySelector(':scope > .zk-main-menu__submenu-toggle');
      const link = li.querySelector(LINK_SELECTOR);
      const title = link ? link.textContent.replace(/\s+/g, ' ').trim() : '';
      collapseItem(li, btn);
      if (btn && title) {
        btn.setAttribute('aria-label', `${expandVerb}: ${title}`);
      }
    });
  });
}

export function initZkMobileNavCollapsible() {
  const panel = document.getElementById(PANEL_ID);
  if (!panel) {
    return;
  }
  bindPanel(panel);
}
